import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import { ZoneCodeBadge } from '@mopla/ui';

import { IZone } from '../types';
import { isWholeNetworkSelection } from '../zones';

interface IZonesCollapsedSummaryProps {
	zones: IZone[];
	selectedZoneIds: string[];
}

export const ZonesCollapsedSummary: FC<IZonesCollapsedSummaryProps> = ({
	zones,
	selectedZoneIds,
}) => {
	const { t } = useTranslation('ticketshop');

	if (selectedZoneIds.length === 0) {
		return (
			<Typography variant="l1" color="error.main">
				{t('ticket_detail.zones_no_selection')}
			</Typography>
		);
	}

	const selectedZones = zones.filter((z) => selectedZoneIds.includes(z.id));
	const includedZones = zones.filter((z) => !selectedZoneIds.includes(z.id));
	const isWholeNetwork = isWholeNetworkSelection(zones, selectedZoneIds);

	return (
		<Stack direction="row" gap={0.5} flexWrap="wrap" alignItems="center">
			{selectedZones.map((z) => (
				<ZoneCodeBadge key={z.id} code={z.zoneCode} />
			))}
			{isWholeNetwork && includedZones.length > 0 && (
				<>
					<Typography variant="l1" color="solutions.600" sx={{ mx: 0.5 }}>
						+
					</Typography>
					{includedZones.map((z) => (
						<ZoneCodeBadge key={z.id} code={z.zoneCode} />
					))}
					<Typography variant="l1" color="solutions.600" sx={{ ml: 0.5 }}>
						({t('ticket_detail.zones_whole_network_label')})
					</Typography>
				</>
			)}
		</Stack>
	);
};
